import "./CSS/basis.css";

import {
    BrowserRouter,
    Routes,
    Route,
    useLocation
} from "react-router-dom";

import {
    useEffect
} from "react";

import Header from "./components/Header";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";

import NewsPage from "./pages/NewsPage";
import NewsDetailPage from "./pages/NewsDetailPage";

import UeberPage from "./pages/UeberPage";
import AngebotePage from "./pages/AngebotePage";
import FreieZeitenPage from "./pages/FreieZeitenPage";
import KontaktPage from "./pages/KontaktPage";
import LinkPage from "./pages/LinkPage";
import FeedbackPage from "./pages/FeedbackPage";

import TantramassagePage
    from "./pages/TantramassagePage";

import KuschelnPage
    from "./pages/KuschelnPage";

import RaumPage
    from "./pages/RaumPage";

import ImpressumPage
    from "./pages/ImpressumPage";

import TantramassageFrauPage
    from "./pages/TantramassageFrauPage";

import TantramassageMannPage
    from "./pages/TantramassageMannPage";

import TantramassagePaarPage
    from "./pages/TantramassagePaarPage";

import LoginPage
    from "./pages/LoginPage";

import AdminPage
    from "./pages/AdminPage";


// ==================================================
// GRUNDEINSTELLUNGEN SEO
// ==================================================

const SITE_URL =
    "https://irj-tantramassagen.ch";


// ==================================================
// SEO-DATEN DER EINZELNEN SEITEN
// ==================================================

const seoData = {

    "/": {
        title:
            "Tantramassage Sarganserland | Mels, Sargans & Bad Ragaz | IRJ",

        description:
            "IRJ-Tantramassagen mit Ivan im Sarganserland. Achtsame Tantramassage für Frauen, Männer und Paare aus Mels, Sargans, Bad Ragaz und Umgebung."
    },


    "/ueber": {
        title:
            "Ivan & Tantra | Über mich | IRJ-Tantramassagen",

        description:
            "Erfahre mehr über Ivan, seinen Weg zur Tantramassage und IRJ-Tantramassagen im Sarganserland bei Mels, Sargans und Bad Ragaz."
    },


    "/angebote": {
        title:
            "Tantramassage Angebote & Preise | Sarganserland | IRJ",

        description:
            "Tantramassage-Angebote für Frauen, Männer und Paare sowie Preise bei IRJ-Tantramassagen im Sarganserland nahe Mels, Sargans und Bad Ragaz."
    },


    "/freiezeiten": {
        title:
            "Freie Termine Tantramassage | IRJ-Tantramassagen",

        description:
            "Aktuelle freie Termine für eine Tantramassage bei IRJ-Tantramassagen im Sarganserland nahe Mels, Sargans und Bad Ragaz."
    },


    "/kontakt": {
        title:
            "Kontakt & Terminanfrage | IRJ-Tantramassagen",

        description:
            "Kontakt zu Ivan von IRJ-Tantramassagen und persönliche Terminanfrage für eine Tantramassage im Sarganserland."
    },


    "/feedback": {
        title:
            "Erfahrungen & Feedback | IRJ-Tantramassagen",

        description:
            "Persönliche Rückmeldungen und Erfahrungen mit IRJ-Tantramassagen und Ivan im Sarganserland."
    },


    "/links": {
        title:
            "Empfehlungen & Links | IRJ-Tantramassagen",

        description:
            "Empfehlungen und weiterführende Links rund um Tantra, Tantramassage und IRJ-Tantramassagen."
    },


    "/tantramassage": {
        title:
            "Tantramassage Sarganserland | Mels, Sargans & Bad Ragaz",

        description:
            "Achtsame Tantramassage bei IRJ-Tantramassagen mit Ivan. Für Frauen, Männer und Paare aus Mels, Sargans, Bad Ragaz und dem Sarganserland."
    },


    "/tantramassage/frau": {
        title:
            "Tantramassage für Frauen | Sarganserland | IRJ",

        description:
            "Achtsame Tantramassage für Frauen und Yoni-Massage bei IRJ-Tantramassagen im Sarganserland nahe Mels, Sargans und Bad Ragaz."
    },


    "/tantramassage/mann": {
        title:
            "Tantramassage für Männer | Sarganserland | IRJ",

        description:
            "Achtsame Tantramassage für Männer und Lingam-Massage bei IRJ-Tantramassagen im Sarganserland nahe Mels, Sargans und Bad Ragaz."
    },


    "/tantramassage/paar": {
        title:
            "Tantramassage für Paare | Sarganserland | IRJ",

        description:
            "Tantramassage für Paare bei IRJ-Tantramassagen im Sarganserland. Für Paare aus Mels, Sargans, Bad Ragaz und der Umgebung."
    },


    "/kuscheln": {
        title:
            "Achtsames Kuscheln & Nähe | Sarganserland | IRJ",

        description:
            "Achtsames Kuscheln, bewusste Nähe und achtsame Berührung bei IRJ im Sarganserland nahe Mels, Sargans und Bad Ragaz."
    },


    "/raum": {
        title:
            "Massageraum im Sarganserland | IRJ-Tantramassagen",

        description:
            "Einblick in den persönlichen Massageraum von IRJ-Tantramassagen im Sarganserland nahe Mels, Sargans und Bad Ragaz."
    },


    "/impressum": {
        title:
            "Impressum | IRJ-Tantramassagen",

        description:
            "Impressum und Anbieterinformationen von IRJ-Tantramassagen."
    }
};


// ==================================================
// SEO-MANAGER
// ==================================================

function SeoManager() {

    const location = useLocation();


    useEffect(() => {

        let data =
            seoData[location.pathname];


        // News-Detailseiten
        if (
            location.pathname.startsWith("/news/")
        ) {

            data = {
                title:
                    "Neuigkeiten | IRJ-Tantramassagen",

                description:
                    "Neuigkeiten und aktuelle Informationen von IRJ-Tantramassagen mit Ivan im Sarganserland."
            };
        }


        // Standardwerte
        if (!data) {

            data = {
                title:
                    "IRJ-Tantramassagen | Tantramassage im Sarganserland",

                description:
                    "IRJ-Tantramassagen mit Ivan – achtsame Tantramassage im Sarganserland nahe Mels, Sargans und Bad Ragaz."
            };
        }


        // ==================================================
        // SEITENTITEL
        // ==================================================

        document.title =
            data.title;


        // ==================================================
        // META-DESCRIPTION
        // ==================================================

        let metaDescription =
            document.querySelector(
                'meta[name="description"]'
            );


        if (!metaDescription) {

            metaDescription =
                document.createElement(
                    "meta"
                );

            metaDescription.setAttribute(
                "name",
                "description"
            );

            document.head.appendChild(
                metaDescription
            );
        }


        metaDescription.setAttribute(
            "content",
            data.description
        );


        // ==================================================
        // ROBOTS
        // ==================================================

        let metaRobots =
            document.querySelector(
                'meta[name="robots"]'
            );


        if (!metaRobots) {

            metaRobots =
                document.createElement(
                    "meta"
                );

            metaRobots.setAttribute(
                "name",
                "robots"
            );

            document.head.appendChild(
                metaRobots
            );
        }


        const isPrivatePage =
            location.pathname === "/login" ||
            location.pathname === "/admin";


        if (isPrivatePage) {

            metaRobots.setAttribute(
                "content",
                "noindex, nofollow"
            );

        }
        else {

            metaRobots.setAttribute(
                "content",
                "index, follow"
            );

        }


        // ==================================================
        // CANONICAL URL
        // ==================================================

        let canonical =
            document.querySelector(
                'link[rel="canonical"]'
            );


        if (!canonical) {

            canonical =
                document.createElement(
                    "link"
                );

            canonical.setAttribute(
                "rel",
                "canonical"
            );

            document.head.appendChild(
                canonical
            );
        }


        const canonicalUrl =
            location.pathname === "/"
                ? `${SITE_URL}/`
                : `${SITE_URL}${location.pathname}`;


        canonical.setAttribute(
            "href",
            canonicalUrl
        );


    }, [location.pathname]);


    return null;
}


// ==================================================
// APP-INHALT
// ==================================================

function AppContent() {

    return (

        <>

            <SeoManager />


            <div
                className="container-index"
                id="top"
            >

                <Header />

                <Navigation />


                <Routes>

                    <Route
                        path="/"
                        element={<NewsPage />}
                    />


                    <Route
                        path="/news/:id"
                        element={<NewsDetailPage />}
                    />


                    <Route
                        path="/ueber"
                        element={<UeberPage />}
                    />


                    <Route
                        path="/angebote"
                        element={<AngebotePage />}
                    />


                    <Route
                        path="/freiezeiten"
                        element={<FreieZeitenPage />}
                    />


                    <Route
                        path="/kontakt"
                        element={<KontaktPage />}
                    />


                    <Route
                        path="/feedback"
                        element={<FeedbackPage />}
                    />


                    <Route
                        path="/links"
                        element={<LinkPage />}
                    />


                    <Route
                        path="/tantramassage"
                        element={<TantramassagePage />}
                    />


                    <Route
                        path="/kuscheln"
                        element={<KuschelnPage />}
                    />


                    <Route
                        path="/raum"
                        element={<RaumPage />}
                    />


                    <Route
                        path="/impressum"
                        element={<ImpressumPage />}
                    />


                    <Route
                        path="/tantramassage/frau"
                        element={
                            <TantramassageFrauPage />
                        }
                    />


                    <Route
                        path="/tantramassage/mann"
                        element={
                            <TantramassageMannPage />
                        }
                    />


                    <Route
                        path="/tantramassage/paar"
                        element={
                            <TantramassagePaarPage />
                        }
                    />


                    <Route
                        path="/login"
                        element={<LoginPage />}
                    />


                    <Route
                        path="/admin"
                        element={<AdminPage />}
                    />

                </Routes>


                <Footer />

            </div>

        </>

    );
}


// ==================================================
// APP
// ==================================================

function App() {

    return (

        <BrowserRouter>

            <AppContent />

        </BrowserRouter>

    );
}


export default App;